<template>
  <div>
    <el-form
      class="elFormClass"
      :model="formParams"
      ref="ruleForm"
      label-width="auto"
      size="small"
    >
      <div class="flex_between_wrap">
       <el-form-item
          style="width:300px;"
          v-for="item in firstItem"
          :key="item.model"
          :label="item.label"
          :prop="item.model"
          :rules="item.rules ? formRules.requiredChange : formRules.not"
        >
          <el-input-number
            clearable
            style="width:100%"
            :controls="false"
            :precision="2"
            :min="0"
            v-if="item.model == 'price'"
            v-model="formParams[item.model]"
            :placeholder="'请输入' + item.label"
          ></el-input-number>
          <x-select
           filterable
    allow-create
    default-first-option
            :isopen="true"
            v-else-if="item.model == 'disposeType'"
            v-model="formParams[item.model]"
            url="/pc/dictionary/page"
            label="defValue"
            model="defValue"
            :params="{ defType: 'dispose',size:9999 }"
          ></x-select>

          <el-date-picker
            style="width:100%"
            v-else-if="item.model == 'startTime'"
            v-model="formParams[item.model]"
            type="date"
            value-format="yyyy-MM-dd"
            :placeholder="`选择` + item.label"
            :picker-options="{
              disabledDate(time) {
                return time.getTime() > Date.now();
              },
              shortcuts: [
                {
                  text: '今天',
                  onClick(picker) {
                    picker.$emit('pick', new Date());
                  },
                },
                {
                  text: '昨天',
                  onClick(picker) {
                    const date = new Date();
                    date.setTime(date.getTime() - 3600 * 1000 * 24);
                    picker.$emit('pick', date);
                  },
                },
                {
                  text: '一周前',
                  onClick(picker) {
                    const date = new Date();
                    date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
                    picker.$emit('pick', date);
                  },
                },
              ],
            }"
          >
          </el-date-picker>
          <el-input type='textarea' autosize v-else v-model="formParams[item.model]"></el-input>
        </el-form-item>
      </div>
    </el-form>

    <el-divider content-position="left"
      ><span class="dividerTitle"
        >待处置资产{{ formParams.ids.length }}</span
      ></el-divider
    >

    <div class="flex_between_nowrap add_asset_all">
      <el-button @click="delasset(delData)">移除资产</el-button>
         <div class="showepc">
        <span
          :style="$dynamicColor($store.state.readyState)"
          style="margin-right:10px"
          >{{ $store.state.readyState }}</span
        >

        <el-button
        
          @click="takeTitlestart(!$store.state.skreadyState)"
          >{{
            $store.state.skreadyState
              ? "关闭扫描"
              : $store.state.readyState !== "已连接"
              ? "开启连接"
              : "开始扫描"
          }}</el-button
        >
        <el-button
          v-show="$store.state.readyState == '已连接'"
          @click="clearEpc"
          >清空缓存</el-button
        >

        <el-popover
          placement="bottom-start"
          width="200"
          @hide="popoverHide(rfidPower)"
          trigger="click"
          :close-delay="500"
        >
          <el-tooltip
            class="item"
            effect="dark"
            content="当前发射功率,支持输入"
            placement="left"
          >
            <el-input-number
              size="small"
              style="width: 100%"
              v-model.number="rfidPower"
              :min="1"
                :max="26"
              label="发射功率"
            ></el-input-number>
          </el-tooltip>

          <el-button style="margin-left:10px"  slot="reference"
            >调整功率</el-button
          >
        </el-popover>
      </div>
       <div style="display:flex">
             <el-input
          style="margin-right:20px;"
          size="small"
          v-model.trim="assetCode"
          clearable
          placeholder="请输入编号进行查询"
        >
          <i
            slot="suffix"
            class="el-input__icon el-icon-search"
            @click="assetCodeSearch(assetCode,'dispose')"
          ></i>
        </el-input>
        <el-button @click="add_asset_minxin">添加资产</el-button>
      </div>
    </div>
    <x-table
      ref="xTable"
      max-height='500'
      :tableData="formParams.asset"
      @selection-change="handleSelectionChange"
        @row-click="table_row_click"

    >
      <el-table-column  type="selection" width="55">
      </el-table-column>
      <el-table-column
        :label="item.label"
        show-overflow-tooltip
        :prop="item.model"
        v-for="item in columnArr"
        :key="item.label"
        ><template slot-scope="scope">
          <div style="width:100%" v-if="item.model == 'assetStatus'">
            <el-tag :style="assetStatusFulter(scope.row[item.model], false)">{{
              assetStatusFulter(scope.row[item.model], true)
            }}</el-tag>
          </div>
            <span
              @click="global_detals(scope.row.id)"
              style=" text-decoration:underline;cursor:pointer"
              v-else-if="item.model == 'assetCode' || item.model == 'assetName'"
              >{{ scope.row[item.model] }}</span
            >
          <span v-else>{{ scope.row[item.model] }}</span>
        </template></el-table-column
      >
    </x-table>

    <div class="dialog_bottom" style="margin-top:20px">
      <el-button class="dialog_close" size="small" @click="closeDialog"
        >取 消</el-button
      >
      <el-button
        class="dialog_submit"
        size="small"
        style="width:100px"
        type="submit"
        @click="submit"
        >确 定</el-button
      >
    </div>
  </div>
</template>
<script>
import { verification, numFulter, modelFulter } from "@/utils/socketFulter";

export default {
  props: {
    callBack: Function,
  },
  data() {
    return {
        assetCode:'',
      rfidPower: 26,
      epcStoreArr: [],

      codeArr: [],
      columnArr: [
        {
          label: "状态",
          model: "assetStatus",
        },
        {
          label: "资产编码",
          model: "assetCode",
        },
        {
          label: "资产名称",
          model: "assetName",
        },
        {
          label: "资产分类",
          model: "assetClassifyName",
        },

        {
          label: "所属组织",
          model: "deptName",
        },
        {
          label: "使用组织",
          model: "useDeptName",
        },
        {
          label: "管理人员",
          model: "assetAdminName",
        },
        {
          label: "使用人",
          model: "usePerson",
        },
        {
          label: "所在区域",
          model: "areaName",
        },
        {
          label: "资产来源",
          model: "sourceName",
        },
        {
          label: "存放地点",
          model: "depositArea",
        },
        {
          label: "规格型号",
          model: "spec",
        },
        {
          label: "计量单位",
          model: "unit",
        },
        {
          label: "价值",
          model: "price",
        },
        {
          label: "使用期限",
          model: "liveTime",
        },
        {
          label: "入库日期",
          model: "inTime",
        },
        {
          label: "供应商",
          model: "supplier",
        },
        {
          label: "联系电话",
          model: "supplierPhone",
        },
        {
          label: "备注",
          model: "remark",
        },
      ],


      formParams: { ids: [],asset:[] },
  delData:[],
      firstItem: [
        {
          label: "处置日期",
          model: "startTime",
          rules: true,
        },
        {
          label: "处置类型",
          model: "disposeType",
          rules: true,
        },

        {
          label: "处置金额",
          model: "price",
          rules: true,
        },
        {
          label: "处置备注",
          model: "remark",
        },
      ],
    };
  },
  watch: {
    "$store.state.resoveMsg"(newval, oldval) {
      /*       if (
        newval &&
        !this.params.assetCode &&
        this.search_value == "assetCode"
      ) {
        this.$store.commit("WEBSOCKET_RFIDOFF");

        this.$set(this.params, "assetCode", newval.substr(6));
      } */
      if (newval.substr(6) !== oldval.substr(6)) {
        console.log("这不是一条重复的数据", newval.substr(6));
        /*  */
        if (!this.epcStoreArrFulter(newval.substr(6), "add")) {
          this.assetEpcSearch(newval.substr(6), "dispose");
        }
      }
    },
  },
  mounted() {
    this.barcode_monitor(this.barCodeCallback)

  },
  beforeDestroy() {
    
  },
  methods: {
    clearEpc() {
      this.epcStoreArr = [];
      this.$store.commit("WEBSOCKET_CLEAR");
    },
    assetEpcSearch(assetEpc, queryType) {
      this.$requestAxiosForm(
        {
          url: "/pc/asset/query",
          data: { assetEpc, queryType },
        },
        (data) => {
          if (data.data && data.data.length) {
            let flag = false;
            if (this.formParams.asset.length) {
              for (let i = 0; i < this.formParams.asset.length; i++) {
                if (data.data[0].id == this.formParams.asset[i].id) {
                  flag = true;
                  break;
                }
              }
            }
            if (!flag) {
              data.data.newEpcCode = assetEpc;
              this.formParams.asset.push(data.data[0]);
            }
          }
                  if (this.formParams.asset && this.formParams.asset.length) {
              this.$set(
                this.formParams,
                "ids",
                this.formParams.asset.map((item) => {
                  return item.id;
                })
              );
            }else{
              this.$set(
                this.formParams,
                "ids",
                []
              );
            }
        }
      );
    },
    /* EPC CRUD */
    epcStoreArrFulter(str, type) {
      let flag = false;
      if (type == "del") {
        for (let i = 0; i < this.epcStoreArr.length; i++) {
          if (this.epcStoreArr[i] == str) {
            this.epcStoreArr.splice(i, 1);
            break;
          }
        }
      }
      if (type == "add") {
        for (let i = 0; i < this.epcStoreArr.length; i++) {
          if (this.epcStoreArr[i] == str) {
            flag = true;
            break;
          }
        }
        if (!flag) {
          this.epcStoreArr.push(str);
        }
      }
      /* flase 通过  */
      return flag;
    },
    takeTitlestart(boolean) {
      if (this.$store.state.readyState !== "已连接" && boolean) {
        this.$store.commit("createSocket");
      } else {
        this.$alertMsg.confirm(
          `确定${boolean ? "开始扫描" : "停止扫描"}吗？`,
          () => {
            this.$store.commit(
              "send",
              boolean
                ? {
                    data: "16DF040201340030",
                    code: 3,
                  }
                : {
                    data: "16DF040201350031",
                    code: 3,
                  }
            );
          }
        );
      }
    },
        popoverHide(data) {
      if (this.rfidPower !== window.localStorage.getItem("zichan_power")) {
        this.$store.commit(
          "send",
      {
            data:
              "16DF04020192" +
              numFulter(data) +
              "00" +
              verification("16DF04010292" + numFulter(data) + "00"),
            code: 3,
          })
        window.localStorage.setItem("zichan_power", data);
      }
    },
      assetCodeSearch(assetCode,queryType ) {
      if (assetCode) {
        this.$requestAxiosForm(
          {
            url: "/pc/asset/query",
            data: { assetCode,queryType },
          },
          (data) => {
            if (data.data&&data.data.length) {
              let flag = false;
              if (this.formParams.asset.length) {
                for (let i = 0; i < this.formParams.asset.length; i++) {
                  if (data.data[0].id == this.formParams.asset[i].id) {
                    flag = true;
                    break;
                  }
                }
              }
              if (!flag) {
                this.formParams.asset.push(data.data[0]);
              } else {
                this.$success("当前资产已在列表中展示", "warning");
              }
            } else {
              this.$success("未查询到数据", "warning");
            }
                     if (this.formParams.asset && this.formParams.asset.length) {
              this.$set(
                this.formParams,
                "ids",
                this.formParams.asset.map((item) => {
                  return item.id;
                })
              );
            }else{
              this.$set(
                this.formParams,
                "ids",
                []
              );
            }
          }
        );
      } else {
        this.$success("请输入条码号后查询", "error");
      }
    },
    table_row_click(row){
  /* 

        @row-click="table_row_click"
   */
this.$refs.xTable.set_checket(row)
},
    barCodeCallback(code) {
      this.assetCode = code;
this.assetCodeSearch(this.assetCode,'dispose');
   
    },
    delasset(data) {
      if (data.length) {
        for (let i = 0; i < data.length; i++) {
            if (data[i].newEpcCode) {
            for (let k = 0; k < this.epcStoreArr.length; k++) {
              if (this.epcStoreArr[k] == data[i].newEpcCode) {
                this.epcStoreArr.splice(k, 1);
                break;
              }
            }
          }
                for(let j=0;j<this.formParams.ids.length;j++){
            if(data[i].id==this.formParams.ids[j]){
              this.formParams.ids.splice(j,1)
            }
          }
          for (let k = 0; k < this.formParams.asset.length; k++) {
            if (data[i].id == this.formParams.asset[k].id) {
              this.formParams.asset.splice(k, 1);
            }
          }
        }
        this.delData = [];
      } else {
        this.$success("请先勾选移除项后操作", "error");
      }
    },
    add_asset_callBack(data,ids) {
      this.formParams.asset = data;
      this.formParams.ids = ids;
      
    },
    add_asset_minxin() {
      this.$createDialog(this, {
        dialogConfig: { title: "选择资产", width: "50%" },
        namespace: "add_selece_asset",
        whetherDestruction: true,

        assemblyConfig: {
          queryType: "dispose",
          columnArr: this.columnArr,
          defaultChecket: this.formParams.asset,
          callBack: this.add_asset_callBack,
        },
      });
    },
        init() {
 
      this.rfidPower = window.localStorage.getItem("zichan_power");
        this.$set(this.formParams, "startTime", this.$getCurrentDate());
     setTimeout(()=>{
         if (this.$store.state.readyState !== "已连接") {
        this.$store.commit("createSocket")
      } else{

        this.$store.commit("send", { data: "16DF040201340030", code: 3 });
      }
     })
  },
    handleSelectionChange(data) {
    this.delData=data
    },
    assetStatusFulter(data, flag) {
      let str = "";
      if (flag) {
        switch (data) {
          case "idle":
            str = "闲置";

            break;

          case "use":
            str = "在用";

            break;
          case "borrow":
            str = "借用";

            break;
          case "repair":
            str = "维修中";

            break;
          case "dispose":
            str = "处置";

            break;
          case "examine":
            str = "审批中";

            break;
        }
      } else {
        switch (data) {
          case "use":
            str = "color:#436bff;background:#d8e6ff;";

            break;
          case "borrow":
            str = "color:#436bff;background:#d8e6ff;";

            break;
          case "examine":
            str = "color:#436bff;background:#d8e6ff;";

            break;

          case "idle":
            str = "color:#42b983;background:#f0f9eb;";

            break;
          case "dispose":
            str = "color:#ffa200;background:#ffefd8;";
            break;
          case "repair":
            str = "color:#ffa200;background:#ffefd8;";
            break;
        }
      }
      return str;
    },

    submit() {
      this.$formValidate(this, "ruleForm").then(() => {
        let submit = JSON.parse(JSON.stringify(this.formParams));
        this.$requestAxiosForm(
          {
            url: "/pc/operate/dispos",
            data: submit,
          },
          (data) => {
            this.$success();
            this.closeDialog();
            this.callBack();
          }
        );
      });
    },
  },
};
</script>
<style scoped>
.dividerTitle {
  font-size: 18px;
  letter-spacing: 0px;
  color: #436bff;
  font-weight: bold;
}
.showepc {
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  justify-content: flex-start;
}
</style>
